module.exports = __webpack_public_path__ + "img/corsymo_logo_white.48775a02.png";